"use client";

import { useEffect } from "react";
import { getCookie } from "@directv-digital/dds.services.cookie-service";

// App Router-safe version of utils/suppressConsoleMethods.ts.
// Cannot use getConfig()/publicRuntimeConfig — throws in RSC/App Router context.
// Uses process.env.NODE_ENV instead; preserves hostname and cookie-override guards.
export function ConsoleSuppressor() {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const cookieValue = getCookie("dtv-allow-console") || "";
    const isDevOrTestHostname =
      /dev\d+/.test(window.location.hostname) ||
      /test\d+/.test(window.location.hostname) ||
      /stage/.test(window.location.hostname);

    if (
      process.env.NODE_ENV === "production" &&
      !isDevOrTestHostname &&
      cookieValue.trim() !== "on"
    ) {
      /* eslint-disable no-console */
      console.log = () => {};
      console.debug = () => {};
      console.warn = () => {};
      console.info = () => {};
      /* eslint-enable no-console */
      // console.error is intentionally NOT suppressed
    }
  }, []);

  return null;
}
